import * as React from 'react';
import Account from './Account';
import Organization from './Organization';
import { History } from 'history';
import { createAccount, IOrganization, IAccount } from '../../services/account';
import { LOGIN_PATH } from '../../constants';
import NavBar from '../../public/shared/NavBar';
import Footer from '../../public/shared/Footer';
import { FormattedMessage, FormattedHTMLMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';

export interface IState {
    organization: IOrganization | null,
    owner: IAccount | null,
    page: number,
    accountState: any
    organizationState: any
}

class Index extends React.Component<InjectedIntlProps & { history: History, location: string }, IState> {
    state = {
        owner: null,
        organization: null,
        page: 0,
        accountState: null,
        organizationState: null
    };

    messages = defineMessages({
        success: {
            id: 'signup.success',
            defaultMessage: 'Thank you for creating your account!  You are now ready to log in and start Harmonizing!'
        },
    });

    componentDidUpdate() {
        window.onpopstate = (e: any) => {
            this.setState({ page: 0 })
        }
    }

    createOrganization = async (organization: IOrganization, file: File | null) => {
        this.setState({ organization })
        if (this.state.owner !== null) {
            const owner: IAccount = this.state.owner!;
            const result = await createAccount({ ...owner, organization: organization.orgName }, organization);
            if (result.success) {
                alert(this.props.intl.formatMessage(this.messages.success))
                this.props.history.push(LOGIN_PATH);
            } else alert(result.message || 'Failed to create account.');
        }
        return;
    };

    createAccount = (owner: IAccount, accountState: any) => {
        this.setState({ owner, page: 1, accountState });
    };

    handleBack = (organizationState: any) => {
        this.setState({ page: 0, organizationState });
    };

    render() {
        return (<React.Fragment>
            <NavBar />
            {this.state.page === 0 ?
                <Account history={this.props.history} createAccount={this.createAccount} state={this.state.accountState} /> :
                <Organization
                    history={this.props.history}
                    createOrganization={this.createOrganization}
                    state={this.state.organizationState}
                    handleBack={this.handleBack}
                />}
            <Footer history={this.props.history} />
        </React.Fragment>)
    };
}

export default injectIntl<{ history: History }>(Index);


// WEBPACK FOOTER //
// ./src/client/create/index.tsx